export default "__VITE_ASSET__BAgExOkr__"